<script>

import {onMount} from "svelte";

let company = null;
let companyProducts = null;


export let batchFilter = null;


let filterData = {

	ProductName: 'Any',
	Date: {
		from: null,
		to: null,
	}

}

onMount(() => {

	var user = localStorage.getItem('user');

	user = JSON.parse(user);

	if(user.company != 'none'){
		company = localStorage.getItem('company');
		company = JSON.parse(company);
		companyProducts = company.Products;
		companyProducts.unshift({name: 'Any'});	
	}

	
});


function searchWithFilters(){


	let auxFilterData = filterData;

	if(auxFilterData.Date.from != null){
		
		auxFilterData.Date.from = formatDate(auxFilterData.Date.from);	
	}
	
	if(auxFilterData.Date.to != null){
		auxFilterData.Date.to = formatDate(auxFilterData.Date.to);	
	}

	batchFilter = auxFilterData;
	auxFilterData = null;	
}

const formatDate = (date) => {

	var newDate = null;
	var splitArray = null;

	/*
		first value year
		second value month
		third value day
	*/
	splitArray = date.split('-');

	newDate = splitArray[2] + '/' + splitArray[1] + '/' +splitArray[0];

	return newDate;


}

	
</script>

<div class="tableFiltersContainer">

	<div class="titleContainer">
		<div class="title">
			Table Filters:
		</div>
	</div>


	<div class="filtersContainer">
		<label class="formLabel">Product Name:</label>

		<select class="formInput formSelect" bind:value={filterData.ProductName}>

			{#if companyProducts != null}
				{#each companyProducts as product}
					<option class="formInputOption" value={product.name}>{product.name}</option>
				{/each}
			{/if}
		</select>

		<label class="formLabel">Production Date:</label>

		<label class="formLabel">From:</label>
		<input class="formInput" type="date" max={filterData.Date.to}  bind:value={filterData.Date.from}> 

		<label class="formLabel">To:</label>
		<input class="formInput" type="date" min={filterData.Date.from} bind:value={filterData.Date.to}>

		<div class="searchBtn" on:click={() => searchWithFilters()}>Search</div>

	</div>

	
</div>




<style>

.tableFiltersContainer{
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	margin-top: 22.5%;


}

.titleContainer{
	width: 100%;
	height: 10%;
	display: flex;
	align-items: center;
	justify-content: center;

}

.title{
	width: 80%;
	height: fit-content;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
}


.filtersContainer{
	width: 100%;
	height: 90%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 5%;



}

.formLabel{
	width: 80%;
	height: 2.770083102493075vh;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
}

.formInput{
	width: 80%;
	height: 5.54016620498615vh;
	border: 0.06510416666666667vw solid white;
	border-radius: 0.1953125vw;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);

}

.formSelect{      
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
	-webkit-appearance: auto;
	-moz-appearance: auto;
	background-color: transparent;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
}


.formInputOption{
	width: 100%;
	height: 33.333333%;
	background-color: white;
	border: 0.06510416666666667vw solid white;
	border-radius: 0.1953125vw;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
}


.searchBtn{
	width: 80%;
	height: 5.54016620498615vh;
	border: 0.06510416666666667vw solid white;
	border-radius: 0.1953125vw;
	background-color: transparent;
	color: black;
	font-size: 0.9114583333333334vw;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
	transform: translateY(-5px);
}

.searchBtn:hover{
		box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
	transform: translateY(0px);
}	





</style>